// extracted by mini-css-extract-plugin
export default {"wrapper":"CookieBanner-module__wrapper--BPlhx","CookieBanner":"CookieBanner-module__CookieBanner--n+WAd"};